const fields = [
  {
    key: 'isCoachRequired',
    type: 'boolean',
    templateOptions: {
      label: 'isCoachRequired'
    },
    display: (field, model) => model.teamApplicationEnabled
  },
  {
    key: 'minPlayers',
    type: 'input',
    templateOptions: {
      attrs: { type: 'number' },
      label: 'minPlayers'
    },
    display: (field, model) => model.teamApplicationEnabled
  },
  {
    key: 'maxPlayers',
    type: 'input',
    templateOptions: {
      attrs: { type: 'number' },
      label: 'maxPlayers'
    },
    display: (field, model) => model.teamApplicationEnabled
  }
]

export default fields
